<template>
  <div class="product-details">
    <div style="padding-bottom:50px">
      <Title text="商品详情" />
      <div class="product-img">
        <div class="img_wrap">
          <img :src="product.imgAddress" alt/>
        </div>
      </div>
      <!-- 商品信息 -->
      <div class="product-message">
        <p class="model">{{product.model}}</p>
        <ul>
          <li>
            <p>品牌:{{product.brand}}</p>
            <p>库存量:{{product.inventory}}</p>
          </li>
          <li>
            <p>封装规格:{{product.pack}}</p>
            <p>最小包装:{{product.mpq}}</p>
          </li>
        </ul>
        <p class="look-file" v-if="product.pdfAddress">
          数据手册：
          <a :href="product.pdfAddress" target="_blank">查看文件</a>
        </p>
        <div class="ensure">
          <div class="list">
            <div class="img">
              <img src="../assets/images/details/zhengpin.png" alt />
            </div>
            <span>正品保证</span>
          </div>
          <div class="list">
            <div class="img">
              <img src="../assets/images/details/fahuo.png" alt />
            </div>
            <span>按时发货</span>
          </div>
        </div>
      </div>
      <!-- 销售价格 -->
      <div class="sales-price">
        <h4>销售价格（含税）</h4>
        <div class="title">
          <span>数量</span>
          <span>价格</span>
        </div>
        <ul>
          <li v-for="(price,index) in product.prices" :key="index">
            <span>{{price.moq}}+</span>
            <span>￥{{price.price}}</span>
          </li>
        </ul>
      </div>
      <!-- 规格参数 -->
      <div class="parameter">
        <h4>规格参数</h4>
        <table border="0">
          <tr v-for="(item,index) in product.introductionVOS" :key="index">
            <td>{{item.title}}</td>
            <td>{{item.value}}</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- footer -->
    <div class="footer">
      <van-goods-action>
        <van-goods-action-icon
          icon="chat-o"
          text="客服"
          url="mqqwpa://im/chat?chat_type=wpa&uin=137394256&version=1&src_type=web&web_src=oicqzone.com"
        />
        <van-goods-action-icon
          icon="cart-o"
          :info="cartNum"
          text="购物车"
          @click="$router.push('/cart')"
        />
        <van-goods-action-button type="warning" text="加入购物车" @click="addCart" />
        <van-goods-action-button type="danger" text="立即购买" @click="onShopButton" />
      </van-goods-action>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '65%' }">
      <div class="popup-product">
        <!-- 商品信息 -->
        <div class="message">
          <div style="overflow:hidden">
            <div class="product-imgs">
              <img :src="product.imgAddress" alt />
            </div>
            <ul class="content">
              <li>{{product.model}}</li>
              <li>品牌：{{product.brand}}</li>
              <li>封装规格：{{product.pack}}</li>
            </ul>
          </div>
          <div class="stock">
            <span>库存：{{product.inventory}}</span>
            <span>最小包装：{{product.mpq}}</span>
          </div>
        </div>
        <!-- 销售价格 -->
        <div class="sales-price">
          <h4>销售价格（含税）</h4>
          <div class="title">
            <span>数量</span>
            <span>价格</span>
          </div>
          <ul>
            <li v-for="(price,index) in product.prices" :key="index">
              <span>{{price.moq}}+</span>
              <span>￥{{price.price}}</span>
            </li>
          </ul>
        </div>
        <!-- 数量 -->
        <div class="product-num">
          <span>数量</span>
          <div class="numInput">
            <van-stepper
              v-model="productNum"
              integer
              button-size="35px"
              :min="1"
              :max="product.inventory"
              input-width="40px"
              @change="changeNum"
            />
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="popup-footer">
        <p>
          金额：
          <span>￥{{total | moneyFilter}}</span>
        </p>
        <button @click="goPayment">确定</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Title from "../components/Title";
import { prodDetail, addCart } from "../request/api";
import { toMoney } from "../common/moneyFilter";
export default {
  name: "product-details",
  data() {
    return {
      show: false,
      productNum: 1,
      product: {},
      cartNum: this.$store.getters.getAllCount,
      unitPrice: 0, //单价
      totalPrice: 0,
      isFirstEnter: true
    };
  },
  created() {
    this.getProdDetails();
  },

  //keep-alive
  beforeRouteEnter(to, from, next) {
    if (from.name == "payment") {
      // 这个name是下一级页面的路由name
      to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = false;
    next();
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      this.getProdDetails(); // 这里发起数据请求，（之前是放在created或者mounted中，现在只需要放在这里就好了，不需要再在created或者mounted中请求！！）
    }
    this.$route.meta.keepAlive = false;
    this.$route.meta.isBack = false; //请求完后进行初始化
    this.isFirstEnter = false; //请求完后进行初始化
  },
  components: {
    Title
  },
  filters: {
    moneyFilter(money) {
      return toMoney(money);
    }
  },
  methods: {
    onShopButton() {
      this.show = true;
    },
    //获取订单详情
    getProdDetails() {
      prodDetail(this.$route.query.productId).then(res => {
        if (res.data) {
          this.product = res.data;
          this.unitPrice = this.product.prices[0].price;
        }
      });
    },
    //加入购物车
    addCart() {
      let product = this.product;
      let data = {
        stockId: product.id,
        qty: product.moq,
        count: 1
      };
      this.$store.dispatch("addCartList", data).then(res => {
        this.cartNum++;
      });
    },
    //输入框数量不得超过库存数量
    changeNum(value) {
      //库存量
      let inventory = this.product.inventory;
      let moq = this.product.moq;
      if (value > inventory) {
        //如果购买商品大于库存量那么提示并且输入框数量为库存量
        this.$toast({
          message: `该商品最多可购买${inventory}件`,
          duration: 2000
        });
        this.productNum = inventory;
      } else if (value < moq) {
        //如果购买商品数量小于起订量那么提示并且输入框数量为起订量
        this.$toast({
          message: `该商品最少购买${moq}件`,
          duration: 2000
        });
        this.productNum = moq;
      }
      //价格阶梯不同价格
      this.product.prices.forEach(element => {
        if (this.productNum > element.moq) {
          this.unitPrice = element.price;
        }
      });
    },
    //确定立即购买
    goPayment() {
      let product = this.product;
      let data = {
        stockId: product.id,
        qty: this.productNum
      };
      addCart(data).then(res => {
        if (res.status == 200) {
          let arr = [];
          arr.push(res.data);
          this.$router.push({
            name: "payment",
            params: {
              paymentId: arr,
              productId: this.$route.params.productId
            }
          });
          sessionStorage.setItem("shopId", JSON.stringify(arr));
          sessionStorage.removeItem('invoice')
        } else {
          this.$toast({
            message: res.msg
          });
        }
      });
    }
  },
  computed: {
    //计算商品总价格
    total() {
      let total = this.productNum * this.unitPrice; //总价
      this.totalPrice = total;
      return total;
    }
  }
};
</script>

<style lang="less" scoped>
.product-details {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.product-img {
  background: #fff;
  padding: 12px 0;
  border-bottom: 1px solid #f2f2f2;
  .img_wrap {
    width: 377px;
    height: 377px;
    margin: 0 auto;
    position: relative;
    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
    }
  }
}
// 商品信息
.product-message {
  padding: 30px;
  background: #fff;
  color: #666;
  font-size: 26px;
  .model {
    color: #333;
    font-size: 32px;
  }
  ul {
    overflow: hidden;
    margin-top: 10px;
    li {
      float: left;
      line-height: 45px;
    }
    li:nth-child(2) {
      float: right;
      margin-right: 35px;
    }
  }
  .look-file {
    margin: 10px 0 20px 0;
    a {
      color: #ff9900;
    }
  }
  .ensure {
    padding-top: 20px;
    border-top: 1px solid #f2f2f2;
    overflow: hidden;
    .list {
      float: left;
      font-size: 22px;
      color: #666;
      .img {
        width: 23px;
        height: 23px;
        vertical-align: bottom;
        margin-right: 10px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .list:nth-child(1) {
      margin-right: 30px;
    }
  }
}
// 销售单价
.sales-price {
  padding: 30px 0;
  background: #fff;
  font-size: 26px;
  color: #333;
  margin: 20px 0;
  h4 {
    font-size: 30px;
    color: #333;
    font-weight: bold;
    margin-left: 30px;
    margin-bottom: 20px;
  }
  .title {
    border-bottom: 1px solid #f2f2f2;
    padding: 20px 0;
    text-align: center;
    span:nth-child(1) {
      margin-right: 186px;
    }
  }
  ul {
    text-align: center;
    li {
      line-height: 50px;
      overflow: hidden;
      span {
        display: inline-block;
        width: 240px;
      }
      span:nth-child(1) {
        text-align: right;
        margin-right: 180px;
      }
      span:nth-child(2) {
        color: #ff6600;
        text-align: left;
      }
    }
  }
}
// 规格参数
.parameter {
  background: #fff;
  padding: 30px;
  color: #333;
  margin-bottom: 100px;
  h4 {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  table {
    width: 100%;
    font-size: 28px;
    border-collapse: collapse;
    td {
      padding: 20px;
    }
  }
  table,
  th,
  td {
    border: 1px solid #e6e6e6;
  }
}
// footer
.van-goods-action {
  width: 100%;
  height: 100px;
  background: #fff;
  border-top: 1px solid #dbdbdb;
}
.van-goods-action-icon {
  width: 92px;
  height: 100px;
  font-size: 24px;
}

.van-goods-action-button {
  height: 100px;
  border-radius: 0;
  font-size: 30px;
}
.van-goods-action-button--last {
  margin-right: 0;
}

// 弹出层
.popup-product {
  padding: 30px;
  .message {
    font-size: 26px;
    color: #666;
    .product-imgs {
      width: 150px;
      height: 150px;
      overflow: hidden;
      border: 1px solid #f2f2f2;
      float: left;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .content {
      margin: 10px 0 0 20px;
      float: left;
      li {
        line-height: 45px;
      }
      li:nth-child(1) {
        font-size: 30px;
        color: #333;
      }
    }
    .stock {
      padding: 20px 0;
      border-bottom: 1px solid #f2f2f2;
      span:nth-child(2) {
        float: right;
      }
    }
  }
  .product-num {
    padding: 20px 0;
    border-top: 1px solid #f2f2f2;
    margin-bottom: 100px;
    span {
      color: #333;
      font-size: 30px;
    }
    .numInput {
      float: right;
    }
  }
}
.popup-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 90px;
  border-top: 1px solid #f2f2f2;
  font-size: 24px;
  display: flex;
  z-index: 99;
  background: #fff;
  p {
    color: #666;
    flex: 1;
    line-height: 90px;
    text-align: center;
    span {
      color: #ff6600;
      font-size: 30px;
      font-weight: bold;
    }
  }
  button {
    border: none;
    flex: 1;
    text-align: center;
    color: #fff;
    background: #ff6600;
  }
}
</style>